export interface Equal<T> {
  (a: T, b: T): boolean;
}

export function identityEqual<T>(a: T, b: T) {
  return Object.is(a, b);
}

export function arrayEqual<T>(element: Equal<T>): Equal<readonly T[]> {
  return (a, b) =>
    a.length === b.length && a.every((e, index) => element(e, b[index]));
}

export const booleanEqual: Equal<boolean> = identityEqual;

export function objectEqual<T>(properties: {
  [K in keyof T]: Equal<T[K]>;
}): Equal<T> {
  const p = <[keyof T, Equal<any>][]>Object.entries(properties);
  return (a, b) => p.every(([key, equal]) => equal(a[key], b[key]));
}

export const numberEqual: Equal<number> = identityEqual;

export const stringCaseInsensitiveEqual: Equal<string> = (a, b) =>
  !a.localeCompare(b, undefined, { sensitivity: "accent" });

export const symbolEqual: Equal<symbol> = identityEqual;

export const stringEqual: Equal<string> = identityEqual;
